var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiveLongMiddleBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 200 30 L 180 30 L 20 20 L 0 20 L 0 180 L 20 180 L 180 170 200 170 ",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 30 20.6 C 30.9 6.1, 51 7.3, 50 21.8",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 30 179.4 C 30.9 193.9, 51 192.7, 50 178.2",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 55 22.3 C 55.9 7.3, 76 8.5, 75 23.5",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 55 177.7 C 55.9 192.7, 76 191.5, 75 176.5",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 80 24 C 80.9 8.5, 101 9.7, 100 25.2",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 80 176 C 80.9 191.5, 101 190.3, 100 174.8",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 105 25.7 C 105.9 9.7, 126 10.9, 125 26.9",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 105 174.3 C 105.9 190.3, 126 189.1, 125 173.1",
    fill: "#aaa",
    stroke: "black",
    strokeWidth: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 65,
    x2: 15,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 65,
    x2: 30,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 65,
    x2: 45,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 65,
    x2: 60,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 65,
    y1: 65,
    x2: 75,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 65,
    x2: 90,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 95,
    y1: 65,
    x2: 105,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 110,
    y1: 65,
    x2: 120,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 125,
    y1: 65,
    x2: 135,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 65,
    x2: 150,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 155,
    y1: 65,
    x2: 165,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 65,
    x2: 180,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 185,
    y1: 65,
    x2: 195,
    y2: 65,
    stroke: "white",
    strokeWidth: 4
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 123,
    x2: 15,
    y2: 123,
    stroke: "white",
    strokeWidth: 4
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 123,
    x2: 30,
    y2: 123,
    stroke: "white",
    strokeWidth: 4
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 123,
    x2: 45,
    y2: 123,
    stroke: "white",
    strokeWidth: 4
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 123,
    x2: 60,
    y2: 123,
    stroke: "white",
    strokeWidth: 4
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 65,
    y1: 123,
    x2: 75,
    y2: 123,
    stroke: "white",
    strokeWidth: 4
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 123,
    x2: 90,
    y2: 123,
    stroke: "white",
    strokeWidth: 4
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 95,
    y1: 124,
    x2: 105,
    y2: 129,
    stroke: "white",
    strokeWidth: 4
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 110,
    y1: 130,
    x2: 120,
    y2: 135,
    stroke: "white",
    strokeWidth: 4
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 125,
    y1: 135,
    x2: 135,
    y2: 135,
    stroke: "white",
    strokeWidth: 4
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 135,
    x2: 150,
    y2: 135,
    stroke: "white",
    strokeWidth: 4
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 155,
    y1: 135,
    x2: 165,
    y2: 135,
    stroke: "white",
    strokeWidth: 4
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 135,
    x2: 180,
    y2: 135,
    stroke: "white",
    strokeWidth: 4
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 185,
    y1: 135,
    x2: 195,
    y2: 135,
    stroke: "white",
    strokeWidth: 4
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 110,
    y1: 100,
    x2: 120,
    y2: 100,
    stroke: "white",
    strokeWidth: 4
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 125,
    y1: 100,
    x2: 135,
    y2: 100,
    stroke: "white",
    strokeWidth: 4
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 100,
    x2: 150,
    y2: 100,
    stroke: "white",
    strokeWidth: 4
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 155,
    y1: 100,
    x2: 165,
    y2: 100,
    stroke: "white",
    strokeWidth: 4
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 100,
    x2: 180,
    y2: 100,
    stroke: "white",
    strokeWidth: 4
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 185,
    y1: 100,
    x2: 195,
    y2: 100,
    stroke: "white",
    strokeWidth: 4
  })), "\n  Sorry, your browser does not support inline SVG.\n");
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiveLongMiddleBack);
export default __webpack_public_path__ + "static/media/FiveLongMiddleBack.fbcf8d0758bbea773f9e7437711b969f.svg";
export { ForwardRef as ReactComponent };